import { EVInvoiceData } from 'src/models/EVInvoice'
import { get } from './axios'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * getInvoice
 */

type GetInvoiceParams = {
  userId: number
  year: number
  month: number
}

export const getInvoice = async ({ userId, ...rest }: GetInvoiceParams) => {
  return await get<EVInvoiceData>(`/v1/users/${userId}/evInvoices`, rest)
}

/**
 * getInvoiceDates
 */

type GetInvoiceDatesParams = {
  userId: number
}

type GetInvoiceDatesResponseData = {
  dates: string[]
}

export const getInvoiceDates = async ({ userId }: GetInvoiceDatesParams) => {
  const data = await get<GetInvoiceDatesResponseData>(`/v1/users/${userId}/evInvoices/dates`)
  return data.dates
}
